module.exports = __webpack_public_path__ + "static/media/icon-manage-class-notification.d615c355.svg";